module.exports = __webpack_public_path__ + "components/MapControl/svg/Tama_jaz.svg?6b1f569a";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Tama_jaz.svg
// module id = 2141
// module chunks = 0